import { Emoji, styled } from '@lessonup/ui-components';
import React from 'react';
import { PinButton, PinButtonProps } from '../PinButton/PinButton';

export type EmojiSize = 'small' | 'medium' | 'large';

export interface PollEmojiButtonProps extends Omit<PinButtonProps, 'label' | 'buttonType' | 'padding'> {
  emoji: string;
  size?: EmojiSize;
}

type PollEmojiButtonThemeSettings = {
  emojiSize: Record<EmojiSize, number>;
};

export const PollEmojiButton: React.FC<PollEmojiButtonProps> = ({ emoji, size = 'medium', ...pinButtonProps }) => {
  const theme: PollEmojiButtonThemeSettings = {
    emojiSize: {
      small: 24,
      medium: 32,
      large: 56,
    },
  };

  const emojiSize = theme.emojiSize[size];

  return (
    <PinButton
      {...pinButtonProps}
      buttonType="secondary"
      padding="small"
      label={
        <StyledEmojiWrapper $emojiSize={emojiSize}>
          <Emoji emoji={emoji} width={emojiSize} height={emojiSize} />
        </StyledEmojiWrapper>
      }
    />
  );
};

const StyledEmojiWrapper = styled.div<{ $emojiSize: number }>`
  padding: 0 calc(${({ $emojiSize }) => $emojiSize}px / 3);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ $emojiSize }) => $emojiSize}px;
  font-size: ${({ $emojiSize }) => $emojiSize}px;
`;
